
import data from '../assets/data/assessment.json'
export const state = () => ({ data })
